import RightSidePanel from './RightSidePanel.vue';
import delay from 'yoctodelay';

const PanelStore = {
  showRightPanel: false,
  isMinimized: false,
  displaySidebar(value: boolean) {
    this.showRightPanel = value;
  },
  async toggleMinimize() {
    document.body.classList.toggle('right-sidebar-mini');
    // we simulate the window Resize so the charts will get updated in realtime.
    const simulateWindowResize = setInterval(() => {
      window.dispatchEvent(new Event('resize'));
    }, 180);

    // we stop the simulation of Window Resize after the animations are completed

    await delay(1000);

    clearInterval(simulateWindowResize);

    this.isMinimized = !this.isMinimized;
  },
};

const RightPanelPlugin = {
  install(app: any) {
    app.mixin({
      data() {
        return {
          panelStore: PanelStore,
        };
      },
    });

    app.config.globalProperties.$rightpanel = PanelStore;
    // Object.defineProperty(Vue.prototype, '$rightpanel', {
    //   get () {
    //     return this.$root.panelStore
    //   }
    // })
    app.component('RightPanel', RightSidePanel);
  },
};

export default RightPanelPlugin;
